// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"541":"6b266936","703":"23976586","787":"c4e80c93"}[chunkId] + ".chunk.js";
};